import React from "react";
import { Typography } from "antd";
import moment from "moment";
import { DATE_TIME_FORMAT } from "@config/constants";

const { Text } = Typography;

const AutionTime = ({ value, ...prop }) => {
    return <Text className="list-item-date" {...prop}>{moment(value).format(DATE_TIME_FORMAT)}</Text>
}

export default AutionTime;